import { endpoints, poster, fetcherGET, fetcher, deleter, patcher, fetcherSwr } from '../utils/axios';
import { useMemo } from 'react';
import useSWR from 'swr';

export function useGetCases(args = {}) {
  const URL = args
    ? [endpoints.cases.getCases, { params: args }]
    : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      cases: data?.data || [],
      isLoading: isLoading,
      tokenError: error,
      tokenValidating: isValidating,
      // rawResponse: response?.data || {},
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}
export function useGetCaseDetails(args = {}) {
  const URL = args
    ? [endpoints.cases.getCaseDetails, { params: args }]
    : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      case: data?.data || [],
      isLoading: isLoading,
      tokenError: error,
      tokenValidating: isValidating,
      // rawResponse: response?.data || {},
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}
export async function useSetCaseInvite(id, args = {}) {
  try {
    const response = await patcher(`${endpoints.cases.setCaseInvite}${id}`, args);
    return response;
  } catch (error) {
    console.error('createCollection error:', error);
    var response = {};
    response.status = false;

    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
}

export async function useSetCloseCase(id, args = {}) {
  try {

    const response = await deleter(
      `${endpoints.cases.setCloseCase}${id}`,
      {
        params: { note: args.note }
      }
    );
    return response;
  } catch (error) {
    console.error("createCollection error:", error);
    return {
      status: false,
      message: error?.response?.data?.message ?? error.message,
    };
  }
}

/**
 * The patient journey for one case: the workflow definition, the recorded steps,
 * the step being answered now and the progress bar, all resolved by the backend.
 */
export function useGetCaseJourney(reportId) {
  const URL = reportId ? endpoints.cases.getCaseJourney(reportId) : null;

  const { data, isLoading, error, isValidating, mutate } = useSWR(URL, fetcherSwr, {
    revalidateOnFocus: false,
  });

  const memoizedValue = useMemo(
    () => ({
      journey: data?.data || null,
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data?.data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

/**
 * Submit one answered step.
 *
 * Resolves rather than throws so the caller can branch on the status the server
 * used: 422 carries a field keyed `errors` map, 409 and 403 carry the current
 * journey in `data`, 428 asks for a confirmation the client owns the copy for.
 */
export async function submitJourneyStep(reportId, body) {
  try {
    const response = await poster(endpoints.cases.submitJourneyStep(reportId), body);

    return {
      ok: true,
      status: 200,
      data: response?.data || null,
      message: response?.message || '',
      errors: null,
    };
  } catch (error) {
    const response = error?.response;

    return {
      ok: false,
      status: response?.status || 0,
      data: response?.data?.data || null,
      message: response?.data?.message || error?.message || 'Something went wrong.',
      errors: response?.data?.errors || null,
    };
  }
}

export async function exportCases(args = {}) {
  try {
    const response = await fetcherGET(endpoints.cases.getCases, { params: args });
    return response;
  } catch (error) {
    console.error('createCollection error:', error);
    var response = {};
    response.status = false;

    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
}